export const options_prop_mp = [
    { label: 'Ozon', value: 1 },
    { label: 'Wildberries', value: 3 },
    { label: 'Yandex', value: 2 },
];